import React from "react";
import {InterferometricStackType} from "../../../../types/product";
import ProductList from "../../../shared/search-results/ProductList";
import {sortProductImagesByAcquisitionDateStartDESC} from "../../../../helpers/productHelper";

interface PropsType {
  interferometricStack: InterferometricStackType
}

const InterferometricStackItemsList = ({
  interferometricStack
}: PropsType) => {
  return (
    <ProductList
      items={sortProductImagesByAcquisitionDateStartDESC(interferometricStack.items)}
      detailsVersion
    />
  )
};

export default InterferometricStackItemsList;
